<section class="lifecycle" data-testid="case-lifecycle" aria-label="Case closeout">
  @if (isLoading()) { <p role="status">Loading case completion and package status...</p> }
  @if (errorState(); as error) {
    <div class="lifecycle__error" role="alert" data-testid="lifecycle-error"><strong>{{ error.title }}</strong>
      @for (message of error.messages; track $index) { <p>{{ message }}</p> }
      @if (!stateLoaded()) { <ui-button severity="secondary" [disabled]="actionsBusy()" (click)="reflectTerminalState()">Retry status</ui-button> }
    </div>
  }
  @if (stateLoaded()) {
    @if (isClosed()) {
      <p class="saved" data-testid="closed-state">Package frozen {{ closeout()!.closedAtUtc | date: 'short' }}. The saved package is read-only.</p>
      <dl><dt>Package reference</dt><dd data-testid="package-reference">{{ closeout()!.packageReference }}</dd><dt>Decision record</dt><dd>{{ closeout()!.decisionRecordId }}</dd></dl>
    }
    @if (isCompleted()) {
      <div data-testid="completed-state"><p class="saved">Case completed@if (completion(); as completed) { {{ completed.completedAtUtc | date: 'short' }} }.</p>
        @if (completion()?.completionReason) { <p class="saved-note">{{ completion()!.completionReason }}</p> }
      </div>
    }
    @if (!isClosed()) {
      <p class="hint">Complete the case after Post-Hearing review, then freeze its final package. Freezing requires an approved, finalized decision.</p>
      @if (!canTransition()) { <p class="hint">You can view closeout status. Completing or freezing requires workflow transition permission.</p> }
      <div class="lifecycle__fields">
        @if (!isCompleted()) { <ui-form [config]="reasonConfig" [formValues]="values" [disabled]="!canAct()" (inputChange)="onInputChange($event)"></ui-form> }
        <div><ui-form [config]="packageConfig" [formValues]="values" [disabled]="!canAct()" (inputChange)="onInputChange($event)"></ui-form><p class="hint">Leave blank to generate a reference when the package is frozen.</p></div>
      </div>
      <div *hearingPhaseBar="'actions'" class="lifecycle__buttons">
        @if (!isCompleted()) { <ui-button severity="primary" data-testid="lifecycle-complete-button" [appTerminologyIdentity]="caseUsage.complete" [disabled]="!canAct()" (click)="completeCase()">{{ caseText.complete() }}</ui-button> }
        <ui-button severity="primary" data-testid="lifecycle-closeout-button" [disabled]="!canAct() || !canCloseOut()" (click)="closeoutCase()">Freeze package</ui-button>
      </div>
    }
  }
</section>
